import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const showJsonViewers = ref(false)
  const screenName = ref('')
  /** Whether the login dialog of the navbar is open; a locked control asks for it too. */
  const loginOpen = ref(false)
  /**
   * Scope the message page opens with once, set when the app opens it from a push notification:
   * the circuit of the message, or ALL_CIRCUITS when it could not be told. Undefined = the page's default.
   */
  const requestedMessageScope = ref<string>()

  function requestMessageScope(scope: string | undefined) {
    requestedMessageScope.value = scope
  }

  function takeMessageScope(): string | undefined {
    const scope = requestedMessageScope.value
    requestedMessageScope.value = undefined
    return scope
  }

  function toggleJsonViewers() {
    showJsonViewers.value = !showJsonViewers.value
  }

  function setScreenName(name: string) {
    screenName.value = name
  }

  function openLogin() {
    loginOpen.value = true
  }

  return {
    showJsonViewers,
    toggleJsonViewers,
    screenName,
    setScreenName,
    loginOpen,
    openLogin,
    requestMessageScope,
    takeMessageScope,
  }
})
